import { Injectable } from '@angular/core';
import { EvaluationAthleteQuestionCategoryProvider } from './evaluation-athlete-question-category-provider.services';
import { Question, QuestionData } from "../../common/models/question";
import { QuestionEvaluation } from "../../common/models/question-evalutation";
import { Evaluation } from "../../common/models/evaluation";
import { EvaluationAthlete } from "../../common/models/evaluation-athlete";
import { Observable, switchMap } from "rxjs";
import { ApiBaseService } from "../../common/providers/api-base-service";
import { map } from "rxjs/operators";

@Injectable({providedIn: 'root'})
export class EvaluationAthleteQuestionProvider {
    constructor(
        private evaluationAthleteQuestionCategoryProvider: EvaluationAthleteQuestionCategoryProvider,
        private api: ApiBaseService,
    ) {}

    /**
     * Find all Question belonging to the evaluation athlete id
     */
    public findByEvaluationAthleteId(organizationId: number, id: number): Observable<Question[]> {
      return this.api.call('GET', `nosync/common-data/questions`,
        {evaluationAthleteId: id}
        ).pipe(
        switchMap((questions: QuestionData[]) => {
          return this.evaluationAthleteQuestionCategoryProvider.findAlll().pipe(
            map((categories) => {
              questions.map((question) => {
                question.category = categories.find(c => c.id === question.questionCategoryId);
              });
              return Question.fromAPIList(questions);
            })
          );
        }),
      );
    }
}
